import React from "react";
import { WORKFLOW_HELP } from "../../../lib/licenceRegistry";

export default function LicenceWorkflowHelp({ className = "mb-3" }) {
  return (
    <div className={`alert alert-light border small ${className}`} role="note">
      {WORKFLOW_HELP}
    </div>
  );
}
